"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hideVisually = _interopRequireDefault(require("../../theming/styles/hideVisually"));

var _Close = _interopRequireDefault(require("../Icons/Close"));

var _animations = require("@staccx/animations");

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

var _ThemeComponent = _interopRequireDefault(require("../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.escFunction = _this.escFunction.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: _this.props.isOpen
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.state.isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      }
    }
  }, {
    key: "escFunction",
    value: function escFunction(event) {
      if (event.keyCode === 27) {
        if (this.props.onClose) {
          this.props.onClose(event);
        }

        this.setState({
          isOpen: false
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      if (this.props.onClose) {
        this.props.onClose(event);
      } // TODO: Make controllable/uncontrollable toggle.


      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "fixOverflow",
    value: function fixOverflow(event) {
      if (this.state.isOpen) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "";
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.escFunction, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.escFunction, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          variant = _this$props.variant,
          otherProps = _objectWithoutProperties(_this$props, ["children", "className", "variant"]);

      var isOpen = this.state.isOpen;
      this.fixOverflow();

      if (isOpen) {
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(ModalItem, _extends({
          className: className
        }, otherProps, {
          role: "dialog",
          tabIndex: "0",
          open: "open",
          "aria-labelledby": "modal",
          variant: variant
        }), _react["default"].createElement(ModalContent, {
          role: "document",
          tabIndex: "0",
          id: "modal",
          variant: variant
        }, _react["default"].createElement(Close, {
          type: "button",
          id: "modal-close",
          "aria-label": "Close (Press escape to close)",
          onClick: this.handleChange
        }, _react["default"].createElement("span", null, "Close"), _react["default"].createElement(Icon, null)), children)), _react["default"].createElement(ModalBackdrop, {
          onClick: this.handleChange,
          variant: variant
        }));
      }

      return null;
    }
  }]);

  return Modal;
}(_react.Component);

Modal.themeProps = {
  dialog: {
    name: "modal_item",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  content: {
    name: "modal_content",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  close: {
    name: "modal_close",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  backdrop: {
    name: "modal_backdrop",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  closeIcon: {
    name: "COMPONENT_MODAL_CLOSE_ICON",
    description: "",
    type: _themeContants.themePropTypes.component
  }
};

var ModalItem = _styledComponents["default"].dialog.withConfig({
  displayName: "Modal__ModalItem",
  componentId: "sc-1jz79rk-0"
})(["border-width:0;height:100%;width:100%;overflow:auto;position:fixed;top:0;left:0;z-index:9999;display:grid;grid-template-columns:24px 1fr 1fr 24px;grid-gap:12px;grid-template-areas:\". . . .\" \". a a .\" \". a a .\" \". . . .\";background:transparent;padding:", " ", " ", " ", ";&:focus{outline:none;}", ";"], _theming.spacing.large, _theming.spacing.small, _theming.spacing.small, _theming.spacing.small, (0, _theming.applyVariants)(Modal.themeProps.dialog));

var ModalContent = _styledComponents["default"].div.withConfig({
  displayName: "Modal__ModalContent",
  componentId: "sc-1jz79rk-1"
})(["background:white;border-radius:", ";grid-area:a;align-self:center;justify-self:center;padding:", " ", " ", " ", ";max-width:", ";min-width:296px;width:100%;overflow-y:auto;position:relative;&:focus{outline:none;}", ";"], _theming.borderRadius, _theming.spacing.large, _theming.spacing.medium, _theming.spacing.medium, _theming.spacing.medium, _theming.wrapper.medium, (0, _theming.applyVariants)(Modal.themeProps.content));

var Close = _styledComponents["default"].button.withConfig({
  displayName: "Modal__Close",
  componentId: "sc-1jz79rk-2"
})(["position:absolute;top:0;right:0;z-index:9999;background:transparent;border-width:0;fill:", ";padding:", ";cursor:pointer;&:focus,&:hover{outline:none;fill:", ";}span{", ";}", ";"], _theming.color.primary, _theming.spacing.small, _theming.color.primary, _hideVisually["default"], (0, _theming.applyVariants)(Modal.themeProps.close));

var ModalBackdrop = _styledComponents["default"].div.withConfig({
  displayName: "Modal__ModalBackdrop",
  componentId: "sc-1jz79rk-3"
})(["position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;background:rgba(0,0,0,0.8);opacity:0;animation:0.2s ", " ease-out forwards 1;", ";"], _animations.FadeIn, (0, _theming.applyVariants)(Modal.themeProps.backdrop));

var IconComponent = function IconComponent(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: Modal.themeProps.closeIcon,
    fallback: _Close["default"]
  }, props));
};

var Icon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "Modal__Icon",
  componentId: "sc-1jz79rk-4"
})([""]);
Modal.defaultProps = {
  isOpen: false,
  className: ""
};
Modal.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
var _default = Modal;
exports["default"] = _default;